"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chevronLeftLarge = _interopRequireDefault(require("@atlaskit/icon/glyph/chevron-left-large"));

var _chevronRightLarge = _interopRequireDefault(require("@atlaskit/icon/glyph/chevron-right-large"));

var _theme = require("@atlaskit/theme");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _util = require("../util");

var _Btn = _interopRequireDefault(require("./Btn"));

var _Heading = require("../styled/Heading");

var ArrowLeft = _styledComponents.default.div.withConfig({
  displayName: "Heading__ArrowLeft",
  componentId: "sc-1wqpjt8-0"
})(["\n  margin-left: 8px;\n"]);

var ArrowRight = _styledComponents.default.div.withConfig({
  displayName: "Heading__ArrowRight",
  componentId: "sc-1wqpjt8-1"
})(["\n  margin-right: 8px;\n"]);

var _default = function _default(props) {
  return _react.default.createElement(_Heading.Heading, {
    "aria-hidden": "true"
  }, _react.default.createElement(ArrowLeft, null, _react.default.createElement(_Btn.default, {
    onClick: props.handleClickPrev
  }, _react.default.createElement(_chevronLeftLarge.default, {
    label: "Last month",
    size: "medium",
    primaryColor: _theme.colors.N70
  }))), _react.default.createElement(_Heading.MonthAndYear, null, "".concat((0, _util.getMonthName)(props.month), " ").concat(props.year)), _react.default.createElement(ArrowRight, null, _react.default.createElement(_Btn.default, {
    onClick: props.handleClickNext
  }, _react.default.createElement(_chevronRightLarge.default, {
    label: "Next month",
    size: "medium",
    primaryColor: _theme.colors.N70
  }))));
};

exports.default = _default;